import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { ApplicationForm } from '../components/JoinTeam/ApplicationForm';
import { Briefcase, PenTool, Monitor } from 'lucide-react';
export const JoinTeam = () => {
  const [showForm, setShowForm] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const roles = [{
    title: 'Community & Programs Lead',
    description: "You'll help manage our members, plan events, and keep our community active and thriving.",
    icon: <Briefcase size={24} className="text-gray-700" data-id="element-1848" />
  }, {
    title: 'Content & Communications Lead',
    description: "You'll create and share stories, social content, and updates that reflect who we are and what we do.",
    icon: <PenTool size={24} className="text-gray-700" data-id="element-1849" />
  }, {
    title: 'Tech & Systems Support',
    description: "You'll handle our digital tools, website updates, and help build smooth online experiences for our members.",
    icon: <Monitor size={24} className="text-gray-700" data-id="element-1850" />
  }];
  const handleFormSubmit = () => {
    setFormSubmitted(true);
  };
  // If the form has been submitted, show only the thank you message
  if (formSubmitted) {
    return <div className="pt-20 bg-white min-h-screen flex items-center justify-center" data-id="element-1851">
        <div className="container mx-auto px-4 py-16" data-id="element-1852">
          <div className="max-w-3xl mx-auto" data-id="element-1853">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-200 text-center" data-id="element-1854">
              <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1855">
                Thank you for applying to join The Networking Salon!
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1856">
                Our team will review your submission and reach out to
                shortlisted applicants for the next steps.
              </p>
              <p className="text-gray-600" data-id="element-1857">
                Keep an eye on your email and WhatsApp for updates.
              </p>
            </div>
          </div>
        </div>
      </div>;
  }
  // If apply button has been clicked, show only the form
  if (showForm) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-1858">
        <div className="container mx-auto px-4 py-16" data-id="element-1859">
          <div className="max-w-3xl mx-auto" data-id="element-1860">
            <ApplicationForm onFormSubmit={handleFormSubmit} data-id="element-1861" />
          </div>
        </div>
      </div>;
  }
  // Default view - show the roles and apply button
  return <div className="pt-20 bg-white" data-id="element-1862">
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-1863">
        <div className="container mx-auto px-4" data-id="element-1864">
          <h1 className="text-4xl font-bold text-center text-gray-800 mb-6" data-id="element-1865">
            JOIN THE NETWORKING SALON TEAM
            <span className="block text-2xl font-medium mt-2 text-gray-600" data-id="element-1866">
              (CONTRACT ROLES)
            </span>
          </h1>
          <p className="text-center text-lg text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-1867">
            We're building a new kind of community — one where ideas meet
            people, and connections turn into real opportunities.
          </p>
          <p className="text-center text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1868">
            The Networking Salon is expanding, and we're inviting passionate,
            creative, and reliable people to join our growing team on a contract
            basis.
          </p>
        </div>
      </section>
      <section className="py-16 border-b border-gray-200" data-id="element-1869">
        <div className="container mx-auto px-4" data-id="element-1870">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-1871">
            Open Roles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-1872">
            {roles.map((role, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6" data-id="element-1873">
                <div className="flex items-center mb-4" data-id="element-1874">
                  <div className="w-10 h-10 border-2 border-gray-300 rounded-full flex items-center justify-center mr-3" data-id="element-1875">
                    {role.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-1876">
                    {role.title}
                  </h3>
                </div>
                <p className="text-gray-600 mb-0" data-id="element-1877">{role.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-1878">
        <div className="container mx-auto px-4" data-id="element-1879">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8" data-id="element-1880">
            About the Contract
          </h2>
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8" data-id="element-1881">
            <ul className="space-y-4 text-gray-600" data-id="element-1882">
              <li className="flex items-start" data-id="element-1883">
                <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3" data-id="element-1884"></div>
                <span data-id="element-1885">Part-time, project-based (3–6 months, renewable)</span>
              </li>
              <li className="flex items-start" data-id="element-1886">
                <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3" data-id="element-1887"></div>
                <span data-id="element-1888">Work remotely or hybrid</span>
              </li>
              <li className="flex items-start" data-id="element-1889">
                <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3" data-id="element-1890"></div>
                <span data-id="element-1891">
                  Payment: Commission or percentage-based on results (details
                  shared during onboarding)
                </span>
              </li>
            </ul>
          </div>
          <p className="text-center text-lg text-gray-600 max-w-3xl mx-auto mt-8" data-id="element-1892">
            If you love building communities, telling stories, or creating
            systems that connect people — this is your chance to grow with us.
          </p>
          <div className="text-center mt-10" data-id="element-1893">
            <Button onClick={() => setShowForm(true)} className="px-8 py-3 text-lg" data-id="element-1894">
              👉 Apply
            </Button>
          </div>
        </div>
      </section>
    </div>;
};